export default (axios) => ({
  getUnprocessedData() {
    return axios.post("/unprocessed")
  }
})